import { AttachFile } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

const PURPOSE_LABEL = {
  comprovante: "Comprovante de pagamento",
  onu: "Foto da ONU / roteador",
  livre: "Leitura livre (IA decide)"
};

/** Nó "Ler arquivo": pede foto/PDF ao cliente, a IA lê e o fluxo segue por "Lido" ou "Não lido". */
export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();
  const varName = data?.variableName || "arquivo";

  return (
    <NodeCard color="#7B3FE4" icon={<AttachFile />} title="Ler arquivo (IA)" id={id} width={224}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={classes.slot}>
        <div style={{ fontWeight: 600 }}>{PURPOSE_LABEL[data?.purpose] || PURPOSE_LABEL.livre}</div>
        <div className={classes.ellipsis} style={{ fontSize: 11, fontWeight: 400, marginTop: 2 }}>
          {"${" + varName + ".resumo}, ${" + varName + ".valor}…"}
        </div>
      </div>
      <div className={classes.outRow} style={{ marginTop: 8 }}>
        <span>Lido</span>
        <NodeHandle type="source" id="a" top="50%" offset={-21} tone="ok" isConnectable={isConnectable} />
      </div>
      <div className={classes.outRow}>
        <span>Não lido</span>
        <NodeHandle type="source" id="b" top="50%" offset={-21} tone="down" isConnectable={isConnectable} />
      </div>
    </NodeCard>
  );
});
